import React from 'react';

import { Header, rem } from '@vimeo/bokeh';

import { enterpriseTemplateProps } from '../../utils/interface';
import { getEnterpriseModalTitle, getEnterpriseSubtitle } from '../../utils/utils';

interface Props {
  modalConfig?: enterpriseTemplateProps;
}

const Title = ({ modalConfig }: Props) => {
  const { enterpriseTitle, enterpriseSubtitle } = modalConfig || {};
  const modalTitle = getEnterpriseModalTitle(enterpriseTitle);
  const modalSubTitle = getEnterpriseSubtitle(enterpriseSubtitle);

  return (
    <>
      {modalTitle && (
        <Header as="h1" size="lg" marginBottom={rem(8)}>
          {modalTitle}
        </Header>
      )}
      {modalSubTitle && (
        <Header as="h3" size="xs" marginBottom={rem(24)}>
          {modalSubTitle}
        </Header>
      )}
    </>
  );
};

export default Title;
